import { Box, Typography } from "@mui/material";
import { NavLink, useMatch } from "react-router-dom";
import {
  Assessment,
  Assignment,
  Policy,
  // HealthAndSafety,
} from "@mui/icons-material";
import {
  // QuestionnaireActiveIcon,
  // QuestionnaireInactiveIcon,
  // EConsentInactiveIcon,
  // EConsentActiveIcon,
  Logo,
  MahaloIcon,
  ConsentIcon,
  ConsentIconActive,
  // AppointmentsActiveIcon,
  // AppointmentsInactiveIcon,
  //   HomeActiveIcon,
  //   HomeInactiveIcon,
} from "../Common/assets/Sidebar";
import { useAppSelector } from "../../Redux/hooks";
import VersionWrapper from "../Common/UI/VersionWrapper";

import SidebarToggle from "./SidebarToggle";
import UserProfileCard from "./UserProfileCard";

type Props = {
  isMobile: boolean;
  userConsented: boolean;
};

const ParticipantSidebar = ({ isMobile, userConsented }: Props) => {
  const collapsed = useAppSelector((state) => state.app.collapsed);

  const matchFunctions: {
    [key: string]: boolean;
  } = {
    home: !!useMatch("/participant/home/*"),
    // questionnaires: !!useMatch("/participant/questionnaires/*"),
    // eConsent: !!useMatch("/participant/e-consent/*"),
    coreSurveys: !!useMatch("/participant/app/core-surveys/*"),
    studySurveys: !!useMatch("/participant/app/study-surveys/*"),
    coreConsents: !!useMatch("/participant/app/core-consents/*"),
    studyConsents: !!useMatch("/participant/app/study-consents/*"),
    // healthRecords: !!useMatch("/participant/app/health-records/*"),
    // appointments: !!useMatch("/participant/appointments/*"),
  };

  return (
    <Box
      className={`sidebar ${collapsed && !isMobile ? "collapsed" : ""} `}
      sx={{
        width: collapsed && !isMobile ? "56px" : "250px",
        "& .user-management-menu": {
          color: "text.secondary",
        },
        "& .active.user-management-menu": {
          color: (theme) => theme.palette.primary.main,
        },
      }}
    >
      <SidebarToggle type="study" />
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 2,
            margin: "10px 0px",
          }}
        >
          {!collapsed ? <Logo /> : <MahaloIcon />}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #1F438A",
            borderRadius: "10px",
            height: "41px",
            p: 1,
            mb: 1.5,
            width: "100%",
          }}
        >
          <UserProfileCard collapsed={collapsed} />
        </Box>
        {/* <NavLink
          to={`/participant/home`}
          title="Home"
          className={({ isActive }) =>
            isActive ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.home ? <HomeActiveIcon /> : <HomeInactiveIcon />}
          {!collapsed && <Typography variant="subtitle1">Home</Typography>}
        </NavLink> */}
        {/* <NavLink
          title="Questionnaires"
          to={`/participant/questionnaires`}
          className={
            matchFunctions.questionnaires ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.questionnaires ? (
            <QuestionnaireActiveIcon />
          ) : (
            <QuestionnaireInactiveIcon />
          )}
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              Questionnaires
            </Typography>
          )}
        </NavLink>
        <NavLink
          title="eConsent"
          to={`/participant/e-consent`}
          className={
            matchFunctions.eConsent ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.eConsent ? (
            <EConsentActiveIcon />
          ) : (
            <EConsentInactiveIcon />
          )}

          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              eConsent
            </Typography>
          )}
        </NavLink> */}
        <NavLink
          title="Core Registry Surveys"
          to={`/participant/app/core-surveys`}
          className={
            matchFunctions.coreSurveys ? "sider-menu active" : "sider-menu"
          }
        >
          <Assessment
            sx={{ color: matchFunctions.coreSurveys ? "white" : "white" }}
          />
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              Core Registry Surveys
            </Typography>
          )}
        </NavLink>
        <NavLink
          title="Study Specific Surveys"
          to={`/participant/app/study-surveys`}
          className={
            matchFunctions.studySurveys ? "sider-menu active" : "sider-menu"
          }
          style={{
            opacity: userConsented ? 1 : 0.5,
            pointerEvents: userConsented ? "auto" : "none",
          }}
        >
          <Assignment
            sx={{ color: matchFunctions.studySurveys ? "white" : "white" }}
          />
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              Study Specific Surveys
            </Typography>
          )}
        </NavLink>
        <NavLink
          title="Core Registry Consents"
          to={`/participant/app/core-consents`}
          className={
            matchFunctions.coreConsents ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.coreConsents ? (
            <ConsentIconActive />
          ) : (
            <ConsentIcon />
          )}
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              Core Registry Consents
            </Typography>
          )}
        </NavLink>
        <NavLink
          title="Study Specific Consents"
          to={`/participant/app/study-consents`}
          className={
            matchFunctions.studyConsents ? "sider-menu active" : "sider-menu"
          }
          style={{
            opacity: userConsented ? 1 : 0.5,
            pointerEvents: userConsented ? "auto" : "none",
          }}
        >
          <Policy
            sx={{ color: matchFunctions.studyConsents ? "white" : "white" }}
          />
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              Study Specific Consents
            </Typography>
          )}
        </NavLink>
        {/* <NavLink
          title="My Health Records"
          to={`/participant/app/health-records`}
          className={
            matchFunctions.healthRecords ? "sider-menu active" : "sider-menu"
          }
          style={{
            opacity: userConsented ? 1 : 0.5,
            pointerEvents: userConsented ? "auto" : "none",
          }}
        >
          <HealthAndSafety
            sx={{ color: matchFunctions.healthRecords ? "white" : "white" }}
          />
          {!collapsed && (
            <Typography variant="body2" fontWeight="regular" ml={1}>
              My Health Records
            </Typography>
          )}
        </NavLink> */}
        {/* <NavLink
          title="Appointments"
          to={`/participant/appointments`}
          className={
            matchFunctions.appointments ? "sider-menu active" : "sider-menu"
          }
        >
          {matchFunctions.appointments ? (
            <AppointmentsActiveIcon />
          ) : (
            <AppointmentsInactiveIcon />
          )}

          {showLabel && <Typography>Appointments</Typography>}
        </NavLink> */}
      </Box>
      <VersionWrapper participant={true} />
    </Box>
  );
};

export default ParticipantSidebar;
